import { Component } from '@angular/core';

@Component({
  selector: 'app-full-page-loading',
  templateUrl: './full-page-loading.component.html',
  styleUrls: ['./full-page-loading.component.scss'],
})
/**
 * Full Page Loading component!
 */
export class FullPageLoadingComponent {}
